<h2 mat-dialog-title *ngIf="isAdding">Legg til kontaktperson</h2>
<h2 mat-dialog-title *ngIf="!isAdding">Bytt kontaktperson</h2>

<mat-dialog-content class="mat-typography">

    <div class="flex-column flex-gap-20">

        <div *ngIf="case?.HasContactInvitation">
            <div class="alert-warning" [innerHtml]="waitingMessage"></div>
        </div>

        <form [formGroup]="newContactForm" novalidate>

            <div class="flex-grow flex-column flex-gap-20">

                <mat-radio-group class="flex-column" formControlName="OnBehalfOf">
                    <mat-radio-button [value]="0">Kontaktperson er privatperson</mat-radio-button>
                    <mat-radio-button [value]="1">Kontaktperson er advokat/rettshjelper</mat-radio-button>
                </mat-radio-group>

                <div class="flex-row flex-gap-20">
                    <div class="flex-column flex-half flex-gap-5">
                        <div class="form-label">Personlig informasjon</div>

                        <!-- fornavn, etternavn-->
                        <mat-form-field class="flex-half flex-grow">
                            <mat-label>Fornavn</mat-label>
                            <input matInput formControlName="FirstName" autocomplete="given-name">
                            <mat-error *ngIf="newContactForm.controls?.FirstName?.errors?.required">
                                Fornavn er et
                                obligatorisk
                                felt</mat-error>
                            <mat-error *ngIf="newContactForm.controls?.FirstName?.errors?.maxlength">
                                Fornavn kan maksimalt
                                inneholde
                                {{newContactForm.controls.FirstName.errors?.maxlength.requiredLength}} tegn</mat-error>
                        </mat-form-field>

                        <mat-form-field class="flex-half flex-grow">
                            <mat-label>Etternavn</mat-label>
                            <input matInput formControlName="LastName" autocomplete="family-name">
                            <mat-error *ngIf="newContactForm.controls?.LastName?.errors?.required">
                                Etternavn er et
                                obligatorisk
                                felt</mat-error>
                            <mat-error *ngIf="newContactForm.controls?.LastName?.errors?.maxlength">
                                Etternavn kan maksimalt
                                inneholde {{newContactForm.controls.LastName.errors?.maxlength.requiredLength}}
                                tegn</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="flex-column flex-half flex-gap-5">
                        <div class="form-label">Kontaktinformasjon</div>

                        <!-- E-post -->
                        <mat-form-field class="flex-grow">
                            <mat-label>E-post</mat-label>
                            <input matInput placeholder="E-post" formControlName="Email" autocomplete="email">
                            <mat-error
                                *ngIf="newContactForm.controls.Email.errors && newContactForm.controls?.Email?.errors?.required">
                                E-post er et obligatorisk felt</mat-error>
                            <mat-error *ngIf="newContactForm.controls?.Email?.errors?.maxlength">E-post kan maksimalt
                                inneholde
                                {{newContactForm.controls.Email.errors?.maxlength.requiredLength}} tegn</mat-error>
                            <mat-error
                                *ngIf="newContactForm.controls.Email.errors && newContactForm.controls?.Email?.errors?.email">
                                Ugyldig e-postadresse</mat-error>
                            <mat-error
                                *ngIf="newContactForm.controls?.Email?.errors && newContactForm.controls?.Email?.errors?.invalidCompareEmail">
                                E-post og bekreft e-post er ikke like</mat-error>

                        </mat-form-field>

                        <!-- Telefon -->
                        <div class="flex-column flex-gap-5">
                            <div class="flex-row flex-gap-10">
                                <mat-form-field style="flex: 0 1 130px" subscriptSizing="dynamic">
                                    <mat-select formControlName="PhoneCountryCode">
                                        <mat-select-trigger>
                                            {{getPhoneDisplayValueFromCountryCode(newContactForm.controls.PhoneCountryCode.value,
                                            false)}}
                                        </mat-select-trigger>
                                        <mat-option *ngFor="let country of filteredCountries | async"
                                            [value]="country.cca2">
                                            {{getPhoneDisplayValueFromCountryCode(country.cca2, true)}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="flex-grow" subscriptSizing="dynamic">
                                    <mat-label>Telefon/mobil</mat-label>
                                    <input matInput placeholder="Telefon/mobil" formControlName="Phone"
                                        autocomplete="tel">
                                </mat-form-field>
                            </div>
                            <div class="error-text-wrapper">
                                <mat-error *ngIf="newContactForm.dirty && newContactForm.controls.Phone?.errors?.required">
                                    Telefonnummer er et obligatorisk felt
                                </mat-error>
                                <mat-error *ngIf="newContactForm.dirty && newContactForm.controls.Phone?.errors?.phoneFormatError">
                                    Ugyldig telefonnummer
                                </mat-error>    
                            </div>    
                        </div>
                    </div>
                </div>

                <div class="flex-row">
                    <div class="alert-warning" role="alert" [innerHtml]="confirmMessage"></div>
                </div>

            </div>
        </form>

    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button type="button" class="finkn-btn" color="primary" mat-raised-button (click)="save()">Legg til</button>
    <button type="button" class="finkn-btn" color="primary" mat-raised-button (click)="close()">Avbryt</button>
</mat-dialog-actions>